var React = require('react');

function ArticlePath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"article-path","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M4.7046301 13.12884136s210.5-85 271 285 571 370.5 601.36811407 240.87001772c30.36811407-129.62998228-106.86811406-150.87001772-152.36811406-49.87001772-45.5 101 122.5 236 397.5 236 156.66666667 0 259.78181818-57.77072544 319.51483318-128.9367059"}));
}

ArticlePath.defaultProps = {"viewBox":"0 0 1446.424 729.833"};

module.exports = ArticlePath;

ArticlePath.default = ArticlePath;
